var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var __privateWrapper = (obj, member, setter, getter) => ({
  set _(value) {
    __privateSet(obj, member, value, setter);
  },
  get _() {
    return __privateGet(obj, member, getter);
  }
});
var _syncId, _handleSectionLoad, _SearchVisibleCount_instances, syncTabs_fn, requery_fn, sync_fn;
const countRequests = /* @__PURE__ */ new Map();
const requeriedUrls = /* @__PURE__ */ new Set();
let headingCount = null;
let headingObserver = null;
let observedHeading = null;
function applyHeadingCount() {
  const el = document.querySelector("[data-search-results-count]");
  if (!el || headingCount === null) return;
  const value = String(headingCount);
  const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
  let textNode = null;
  while (walker.nextNode()) {
    if (walker.currentNode.nodeValue.trim()) textNode = walker.currentNode;
  }
  if (!textNode) {
    el.textContent = value;
  } else if (textNode.nodeValue.trim() !== value) {
    textNode.nodeValue = value;
  }
}
function setHeadingCount(count) {
  var _a;
  headingCount = count;
  applyHeadingCount();
  const heading = (_a = document.querySelector("[data-search-results-count]")) == null ? void 0 : _a.closest(".sc-page-heading-title-heading");
  if (!heading || heading === observedHeading) return;
  headingObserver == null ? void 0 : headingObserver.disconnect();
  headingObserver = new MutationObserver(applyHeadingCount);
  headingObserver.observe(heading, { childList: true, subtree: true, characterData: true });
  observedHeading = heading;
}
function searchUrlWithTypes(types) {
  const params = new URLSearchParams(window.location.search);
  if (types) params.set("type", types);
  else params.delete("type");
  params.delete("page");
  return `${Theme.routes.search_url || "/search"}?${params.toString()}`;
}
function fetchTypeCount(type) {
  const params = new URLSearchParams(window.location.search);
  params.set("type", type);
  params.delete("page");
  params.set("section_id", "search-type-count");
  const url = `${Theme.routes.search_url || "/search"}?${params.toString()}`;
  if (!countRequests.has(url)) {
    countRequests.set(
      url,
      fetch(url).then((response) => response.ok ? response.text() : "").then((html) => parseInt(new DOMParser().parseFromString(html, "text/html").body.textContent.trim(), 10) || 0).catch(() => {
        countRequests.delete(url);
        return 0;
      })
    );
  }
  return countRequests.get(url);
}
class SearchVisibleCount extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _SearchVisibleCount_instances);
    __privateAdd(this, _syncId, 0);
    __privateAdd(this, _handleSectionLoad, () => __privateMethod(this, _SearchVisibleCount_instances, sync_fn).call(this));
  }
  connectedCallback() {
    var _a;
    __privateMethod(this, _SearchVisibleCount_instances, sync_fn).call(this);
    if ((_a = window.Shopify) == null ? void 0 : _a.designMode) document.addEventListener("shopify:section:load", __privateGet(this, _handleSectionLoad));
  }
  disconnectedCallback() {
    document.removeEventListener("shopify:section:load", __privateGet(this, _handleSectionLoad));
  }
  attributeChangedCallback() {
    if (this.isConnected) __privateMethod(this, _SearchVisibleCount_instances, sync_fn).call(this);
  }
}
_syncId = new WeakMap();
_handleSectionLoad = new WeakMap();
_SearchVisibleCount_instances = new WeakSet();
syncTabs_fn = function(hiddenTypes, visibleTypes) {
  document.querySelectorAll("results-tab [data-tab-type]").forEach((tab) => {
    const tabType = tab.dataset.tabType;
    const hidden = hiddenTypes.includes(tabType);
    tab.classList.toggle("hidden", hidden);
    const divider = tab.previousElementSibling;
    if (divider == null ? void 0 : divider.classList.contains("result-tabs-btn-divider")) divider.classList.toggle("hidden", hidden);
    if (tabType !== "all") return;
    const allTypes = hiddenTypes.length && visibleTypes ? visibleTypes : "";
    if (allTypes) tab.dataset.tabTypes = allTypes;
    else delete tab.dataset.tabTypes;
    const link = tab.querySelector("a[href]");
    if (!link) return;
    const url = new URL(link.getAttribute("href"), window.location.origin);
    if (allTypes) url.searchParams.set("type", allTypes);
    else url.searchParams.delete("type");
    link.setAttribute("href", `${url.pathname}${url.search}`);
  });
};
// Re-request the listing with the visible types. Returns false when that is not possible or is
// already in flight for this URL, so the caller falls back to adjusting the count.
requery_fn = function(types) {
  const url = searchUrlWithTypes(types);
  if (requeriedUrls.has(url)) return false;
  const facetsForm = document.querySelector("facets-form-component");
  if (!facetsForm || typeof facetsForm.updateFiltersByURL !== "function") return false;
  requeriedUrls.add(url);
  Promise.resolve(facetsForm.updateFiltersByURL(url, false, false, true)).finally(() => requeriedUrls.delete(url));
  return true;
};
sync_fn = async function() {
  const syncId = ++__privateWrapper(this, _syncId)._;
  const hiddenTypes = (this.dataset.hiddenTypes || "").split(" ").filter(Boolean);
  const visibleTypes = this.dataset.visibleTypes || "";
  const requeryTypes = this.dataset.requeryTypes || "";
  const type = this.dataset.type || "all";
  __privateMethod(this, _SearchVisibleCount_instances, syncTabs_fn).call(this, hiddenTypes, visibleTypes);
  if (requeryTypes && __privateMethod(this, _SearchVisibleCount_instances, requery_fn).call(this, requeryTypes)) return;
  let count = parseInt(this.dataset.count, 10) || 0;
  if (hiddenTypes.includes(type)) {
    count = 0;
  } else if (requeryTypes) {
    const hiddenCounts = await Promise.all(hiddenTypes.map(fetchTypeCount));
    count = Math.max(0, hiddenCounts.reduce((total, hiddenCount) => total - hiddenCount, count));
  }
  if (syncId !== __privateGet(this, _syncId)) return;
  setHeadingCount(count);
};
__publicField(SearchVisibleCount, "observedAttributes", [
  "data-count",
  "data-type",
  "data-hidden-types",
  "data-visible-types",
  "data-requery-types"
]);
if (!customElements.get("search-visible-count")) {
  customElements.define("search-visible-count", SearchVisibleCount);
}
